import React from 'react'
import PropTypes from 'prop-types'
import { FormListItem } from 'shared/components'

const AddressInfoComponent = ({ onClick }) => (
	<FormListItem
		title="Address data"
		description="Update your address information"
		onClick={onClick}
	/>
)

AddressInfoComponent.propTypes = {
	onClick: PropTypes.func.isRequired,
}

export default AddressInfoComponent 